/* eslint-disable react-hooks/exhaustive-deps */
/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { ReactElement, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import i18next from "i18next";
import { useSelector } from "react-redux";
import { ILanguages } from "../types/ILanguages";
import { Storage } from "../config/storage-util";
import { IRootState } from "../config/reducers";
import { getLanguages } from "../pages/settingAccount/ducks/opertations";
import { useAppDispatch } from "../config/store";

const Footer = (): ReactElement => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const { languages } = useSelector(
    (state: IRootState) => state.settingAccountReducer
  );
  const { account, isAuthenticated } = useSelector(
    (state: IRootState) => state.loginReducer
  );
  const [selectedLanguage, setSelectedLanguage] = useState({} as ILanguages);

  useEffect(() => {
    if (!isAuthenticated) dispatch(getLanguages());
  }, [isAuthenticated]);

  useEffect(() => {
    if (account?.localisation) {
      Storage.local.set("locale", account?.localisation?.locale || "");
      setSelectedLanguage(
        languages.find((x) => x.code === account?.localisation?.locale || "") ||
          {}
      );
    }
  }, [account, languages]);

  useEffect(() => {
    if (languages.length > 0 && !account) {
      const browserLanguage =
        window.navigator.language === "en-US"
          ? "en"
          : window.navigator.language;
      const browserSelected = languages.find((x) => x.code === browserLanguage);
      const selected = browserSelected
        ? browserSelected
        : languages.find((x) => x.code === "en");
      setSelectedLanguage(selected || {});
    }
  }, [languages, account]);

  useEffect(() => {
    const changeLanguage = async () => {
      await i18next.changeLanguage(selectedLanguage.code);
    };
    if (selectedLanguage) {
      changeLanguage();
    }
  }, [selectedLanguage]);

  const dropdownShowPaths = ["/login", "/"];
  const [show, setShow] = useState<boolean>(false);
  const currentPathName = pathname;

  const handleLanguageChange = async (language: ILanguages) => {
    if (dropdownShowPaths.includes(currentPathName)) {
      Storage.local.set("locale", language.code || "");
      setSelectedLanguage(language);
    }
  };

  return (
    <>
      <div className="navbar navbar-expand-lg navbar-light footer">
        <div className="text-center d-lg-none w-100">
          <button
            type="button"
            className="navbar-toggler dropdown-toggle"
            data-toggle="collapse"
            data-target="#navbar-footer"
            onClick={() => setShow(!show)}
          >
            <i className="icon-unfold mr-2" />
            Footer
          </button>
        </div>
        <div
          className={`navbar-collapse collapse ${show ? "show" : ""}`}
          id="navbar-footer"
        >
          <span className="navbar-text">
            <span>
              {" "}
              © {new Date().getFullYear()} AdvaPACS by{" "}
              <a href="https://adva.health" target="_blank">
                AdvaHealth Solutions
              </a>
            </span>{" "}
          </span>
          {dropdownShowPaths.includes(currentPathName) && (
            <div className="navbar-nav ml-lg-auto">
              <Dropdown className="nav-item dropdown custom-dropdown" drop="up">
                <Dropdown.Toggle>{selectedLanguage?.name}</Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu dropdown-menu-right footer-language">
                  {languages.map((language) => (
                    <Dropdown.Item
                      key={language.code}
                      className="dropdown-item"
                      onClick={() => handleLanguageChange(language)}
                    >
                      <i className={`flag-sm ${language.flag}`} />
                      <span>{language.name}</span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Footer;
